import { Route } from '@angular/router';

import { HomeComponent } from './views/pages/home/home.component';

export const AppRoutes: Route[] = [
  {
    path: '',
    loadChildren: () =>
      import('./layouts/default/default.module').then((m) => m.DefaultModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./layouts/simple/simple.module').then((m) => m.SimpleModule),
  },
  {
    path: 'health',
    loadComponent: () => import('./app.health').then((m) => m.AppHealth),
  }
];
